// extracted by mini-css-extract-plugin
export default {"container":"EmailShare_container__he1xC","shareEmailBtn":"EmailShare_shareEmailBtn__IhHLo","emailSvg":"EmailShare_emailSvg__28C6g"};